module.exports = {"new":{"header":"Welcome to {{ partnerName }}","sub_header":"Account successfully created"},"close":"close"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/welcome.json
// module id = 541
// module chunks = 245 946